import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EventCalendarDetailModel } from '../../../model/events';
import { hideDetailEvent } from '../../../actions/events';
import { CalendarEventHour } from '../../core/CalendarEvent';

/**
 * Shows info about an event: Description, location and all the dates for this event
 * @param {EventCalendarDetailModel} event - All the info about the event. Obtained by Redux
 * @param {function} hideEvent - Function to destroy this component. Obtained by Redux
 */
const EventCalendarDetail = ({ event, hideEvent, user, daySelected }) => (
  <CalendarEventHour
    dataEvent={event}
    onClick={hideEvent}
    user={user}
    daySelected={daySelected}
  />
);

EventCalendarDetail.propTypes = {
  event: EventCalendarDetailModel,
  hideEvent: PropTypes.func
};

const mapStateToProps = ({ events, user }) => ({
  event: events.detail,
  user: user.user
});

const mapDispatchToProps = dispatch => ({
  hideEvent: () => hideDetailEvent(dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventCalendarDetail);
